import { options } from '../config/options';
import { rgIDs } from '../../shared/constants/domIDs';
import { messengerURLs } from '../../shared/constants/urls';

window.RGMessengerComponent = window.zoid.create({
  ...options,
  tag: rgIDs.messenger,
  url: messengerURLs,
});
